<div id="zoomControls">
  <span id="zoom-in"><img alt="plus" src="assets/plus.svg" /></span>
  <span id="zoom-out"><img alt="minus" src="assets/minus.svg" /></span>
</div>
